import React from 'react';
import injectSheet from 'react-jss'
import { HashRouter, Route, Redirect } from 'react-router-dom'
import SanFrancisco from '../fonts/SFUIText-Regular.ttf'
import windowSize from 'react-window-size';
import { Row, Col } from 'react-flexbox-grid'

import InternationalCities from './Locations/InternationalCities.jsx'
import USCities from './Locations/USCities.jsx'
import Header from './Header.jsx'
import AboutPage from './AboutPage.jsx'
import SetLocationPage from './SetLocationPage.jsx'
import SeeEvents from './SeeEventsPage.jsx'
import EventInformation from './EventInformation.jsx'
import HomePage from './HomePage.jsx'

import gPlay from '../img/gplay.png'
import apStore from '../img/astore.png'

import createHashHistory from 'history/createHashHistory'
const history = createHashHistory()


const styles = {
  '@font-face': {
    fontFamily: 'SanFrancisco',
    src: `url('${SanFrancisco}') format("truetype")`
  },
  gPlay: {
    width: '300px',
  },
  apStore: { 
    extend: 'gPlay',
  },
  root: {
    maxWidth: '1170px',
    margin: '0 auto'
  },
  mobileContentRoot: {
    background: 'white',
    padding: '20px 15px 30px' 
  },
  mobileImgContainer: {
    display: 'inline-block'
  },
  mobileContainer: {
    margin: '60px auto 0',
    textAlign: 'center'
  },
  mobileTitle: {
    textAlign: 'center',
    fontSize: '26px',
    fontWeight: '500',
  },
  mobileSubtitle: {
    marginTop: '20px',
    fontSize: '18px',
    textAlign: 'center',
  },
}

class Main extends React.Component {
  state = {
    events: {},
    currentCity: null,
    currentEvent: null,
    urlLocation: history.location.pathname.slice(1)
  }

  componentDidMount() {
    history.listen(() => this.setState({
      urlLocation: history.location.pathname.slice(1)
    }))
  }

  gotoUrl(url){
    history.push(url)
  }

  fetchEvents(param) {
    this.gotoUrl('events')
    fetch(`https://unitedcor.org/admin/events/in/${param}`)
    .then(res => res.json())
    .then(res => {
      this.setState({
        events: {
          ...this.state.events,
          [param]: res.data
        },
        currentCity: param
      })
    })
  }

  featuredEvent() {
    this.gotoUrl('events')
    fetch(`https://unitedcor.org/admin/events/featured`)
    .then(res => res.json())
    .then(res => {
      this.setState({
          events: {
            ...this.state.events,
            featured: res.data
          },
          currentCity: 'featured'
        })
      })
    }

    setEvent(event) {
      this.setState ({
        currentEvent: event
      } , () => this.gotoUrl('event'))
    }

  render() {
    const { classes, windowWidth } = this.props
    const { events, currentCity, currentEvent, featuredEvent, urlLocation } = this.state

    const MobileContent = () => 
      <div className={classes.mobileContentRoot}>
        <div>
          <div className={classes.mobileTitle}>Please download our App</div>
          <div className={classes.mobileSubtitle}>Download it from either the Google Play Store or from iTunes, below.</div>
        </div>
        <div className={classes.mobileContainer}>
          <div className={classes.mobileImgContainer}onClick={() => window.location.href='https://play.google.com/store/apps/details?id=com.unitedcor&hl=en'}><img src={gPlay} className={classes.gPlay}/></div>
          <div className={classes.mobileImgContainer}onClick={() => window.location.href='https://itunes.apple.com/us/app/unitedcor/id1192321277?mt=8'}><img src={apStore} className={classes.apStore}/></div>
        </div>
      </div>
    return (
      windowWidth > 1200 ? 
      <HashRouter history={history}>
        <div>
          <Header urlLocation={urlLocation} />
          <Redirect exact from="/" to="/home_page" />
          <Route path='/about' component={AboutPage} />
          <Route path='/events' render={() => <SeeEvents events={events[currentCity]} currentCity={currentCity}setEvent={this.setEvent.bind(this)} gotoUrl={this.gotoUrl.bind(this)} />} />
          <Route path='/location' render={() => <SetLocationPage fetchEvents={this.fetchEvents.bind(this)} featuredEvent={this.featuredEvent.bind(this)} />} />
          <Route path='/usCities' render={() => <USCities fetchEvents={this.fetchEvents.bind(this)} />} />
          <Route path='/interCities' render={() => <InternationalCities fetchEvents={this.fetchEvents.bind(this)}/>} />
          <Route path='/event' render={() => <EventInformation currentEvent={currentEvent} gotoUrl={this.gotoUrl.bind(this)} />} />
          <Route path='/home_page' render={() => <HomePage gotoUrl={this.gotoUrl.bind(this)} />} />
        </div>
      </HashRouter> 
      : <MobileContent />
    );
  }
}

export default windowSize(injectSheet(styles)(Main))



// WEBPACK FOOTER //
// ./src/components/Main.js